import { isClient } from '~/utils/userAgent'

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const getLocalStorage = (key: string) => {
  if (!isClient) return null
  const item = window?.localStorage?.getItem(key)
  return item ? JSON.parse(item) : null
}

export const compareString = (first: string, second: string) => {
  return first?.toLowerCase() === second?.toLowerCase()
}
